import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/dataprocessing/analytics.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/dataprocessing/datacleaning.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/dataprocessing/datacoding.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/dataprocessing/datatransformation.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/dataprocessing/forecasting.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/dataprocessing/statisticalanalysis.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/DataCollectionMobileCarousel/index.tsx");
